"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVehiculeByIdQuery = exports.useDeleteVehiculeMutation = exports.useGetVehiculesQuery = exports.useAddOrUpdateVehiculeMutation = exports.VehiculeApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.VehiculeApi = (0, react_1.createApi)({
    reducerPath: "vehiculeApi",
    tagTypes: ["vehicule", "vehiculeList", "vehiculeById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        addOrUpdateVehicule: builder.mutation({
            invalidatesTags: ["vehicule", "vehiculeList", "vehiculeById"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `vehicle-types/${id}/`,
                        method: "PUT",
                        body: data,
                    };
                }
                return {
                    url: `vehicle-types/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        getVehicules: builder.query({
            providesTags: ["vehiculeList"],
            query: (query) => (0, Utils_1.QueryUrl)("vehicle-types", query),
        }),
        vehiculeById: builder.query({
            query: (id) => `vehicle-types/${id}/`,
            providesTags: ["vehiculeById"],
        }),
        deleteVehicule: builder.mutation({
            query: (id) => ({
                url: `vehicle-types/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["vehicule", "vehiculeList", "vehiculeById"],
        }),
    }),
});
exports.useAddOrUpdateVehiculeMutation = exports.VehiculeApi.useAddOrUpdateVehiculeMutation, exports.useGetVehiculesQuery = exports.VehiculeApi.useGetVehiculesQuery, exports.useDeleteVehiculeMutation = exports.VehiculeApi.useDeleteVehiculeMutation, exports.useVehiculeByIdQuery = exports.VehiculeApi.useVehiculeByIdQuery;
